



































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { store, TechnicalInvoiceStore } from "../services/TechnicalInvoiceStore";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { t } from "@/plugins/i18n";

interface Data {
  loading: boolean;
  store: TechnicalInvoiceStore;
}

interface Methods {
  createTechnicalInvoice(): void;
  editTechnicalInvoice(data: any): void; // muszáj az any type, mert az ApiSearchból érkezik a data és nincs külön modell megírva neki - asszem
}

export default Vue.extend<Data, Methods, {}>({
  components: {
    ApiSearchPage,
  },

  data() {
    return {
      loading: false,
      store,
    };
  },

  methods: {
    createTechnicalInvoice() {
      this.$router.push(`/invoice-browser/technical-invoice/${this.$route.params.codeFilter}`);
    },

    async editTechnicalInvoice(invoiceId) {
      // console.log(invoiceId); // a hlaccinvoice_bg-bol kapott viri/viro szamlanak az id-ja
      this.$router.push(`/invoice-browser/technical-invoice/${this.$route.params.codeFilter}/edit/${invoiceId}`);
    },
  },

  computed: {
    createButtonText() {
      return t("TechnicalInvoice_UjTechnikaiSzamlaFelvetele");
    },

    titleText() {
      if (this.$route.params.codeFilter === "viro") return t("TechnikaiKimenoSzamlak");
      if (this.$route.params.codeFilter === "viri") return t("TechnikaiBejovoSzamlak");
      return t("Szamlak");
    },

    // data a backendről jön az ApiSearch segítségével, csak az oszlopokat kell beállítani
    columns: (): ApiSearchColumn[] => [
      // {
      //   field: "id",
      //   title: "ID",
      //   filterable: false,
      // },
      {
        field: "invoice",
        title: t("Azonosito"),
      },
      {
        field: "invPartnerName",
        title: t("Partner"),
      },
      {
        field: "pmodeName",
        title: t("FizetesiMod"),
      },
      {
        field: "netto",
        title: t("Netto"),
      },
      {
        field: "vat",
        title: t("Afa"),
      },
      {
        field: "total",
        title: t("Brutto"),
      },
      {
        field: "currency",
        title: t("Devizanem"),
      },
      {
        field: "invDate",
        title: t("SzamlaDatuma"),
        type: ColumnType.Date,
        filterable: false,
      },
      {
        field: "shipDate",
        title: t("TeljesitesDatuma"),
        type: ColumnType.Date,
        filterable: false,
      },
      { cell: "commandTemplate", filterable: false },
    ],
  },
});
